/**
 * Berichten store (field-app) — count polling voor de dashboard-/nav-badge.
 * Telt open berichten van kantoor (office_to_field) die de uitvoering moet oppakken.
 */

import { create } from 'zustand'
import { fetchBerichtCounts, type BerichtCounts } from '../lib/berichten'

interface State {
  counts: BerichtCounts
  pollingIntervalId: ReturnType<typeof setInterval> | null

  refresh: () => Promise<void>
  startPolling: (intervalMs?: number) => void
  stopPolling: () => void
}

const EMPTY: BerichtCounts = { open: 0, total: 0 }

export const useBerichtenStore = create<State>()((set, get) => ({
  counts: EMPTY,
  pollingIntervalId: null,

  refresh: async () => {
    try {
      const counts = await fetchBerichtCounts()
      set({ counts })
    } catch (err) {
      console.warn('[berichten] count refresh error:', err)
    }
  },

  startPolling: (intervalMs = 60_000) => {
    const { pollingIntervalId, refresh } = get()
    if (pollingIntervalId) return
    refresh()
    const id = setInterval(() => refresh(), intervalMs)
    set({ pollingIntervalId: id })
  },

  stopPolling: () => {
    const { pollingIntervalId } = get()
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId)
      set({ pollingIntervalId: null })
    }
  },
}))
